// eslint-disable-next-line no-unused-vars
import React, { useState, lazy, Suspense } from 'react';
import logo1 from '../../assets/logo_fondo_blanco_1.webp';

import styles from './Footer.module.css';
import scrollTop from '../../utils/helpers/scrollTop';

import Modal from '../Modal/Modal';
import Loader from '../Loader';

const AboutMe = lazy(() => import('../AboutMe/AboutMe'));

const Footer = () => {
  const [modal, setModal] = useState(false);

  return (
    <>
      <Modal
        openModal={modal}
        fnCloseModal={() => setModal(false)}
        styleContent={styles.modalContent}
      >
        <Suspense fallback={<Loader />}>
          <AboutMe />
        </Suspense>
      </Modal>
      <footer className={styles.footer}>
        <div className={styles.footerContainer}>
          <div className={styles.img}>
            <img
              width="300px"
              height="300px"
              src={logo1}
              className={styles.logoImg}
              alt=""
            />
          </div>
          <p>
            💻 - Construido por{' '}
            <button
              type="button"
              onClick={() => setModal(true)}
              className={styles.userBtn}
              aria-label="Mostrar información sobre el desarrollador"
            >
              @Alejandro Guzman
            </button>{' '}
            con 💜 en 2024 &#x1F1F2;&#x1F1FD;
          </p>
          <button
            title="Regresar arriba"
            name="Regresar arriba"
            type="button"
            className={styles.floatBtn}
            onClick={scrollTop}
            aria-label="Regresar arriba"
          >
            <i className="fas fa-angle-double-up" />
          </button>
        </div>
        <p className={styles.visitas}>
          Num. Visitas
          <img
            width="20px"
            height="10px"
            src="https://counter8.optistats.ovh/private/contadorvisitasgratis.php?c=weq8s9t9526cmrydl58yujcerw8a7jwc"
            border="0"
            title="contador de visitas"
            alt="contador de visitas"
          />
        </p>
      </footer>
    </>
  );
};

export default Footer;
